<template>
  <div>
    <div class="feedback">
      <transition name="fade" @enter="enterSuccessFeedback">
        <FeedbackSuccess
          v-if="showableSuccessFeedback"
          :message="successMessage"
        />
      </transition>
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <div v-if="showEmpty">
      <WishListContentEmptyForCurrentUser
        v-if="isCurrentUser"
        :items-path="itemsPath"
      />
      <WishListContentEmptyForOtherUser
        v-else
        :is-wish-list-ticket-loading="isUserWishListsLoading"
        :is-wish-list-item-present="isWishListItemPresent"
        :nickname="nickname"
      />
    </div>
    <div v-else>
      <div v-if="isUserWishListsLoading" class="wish-list-contents__container">
        <div class="wish-list-contents__loading">
          <SmallLoading />
        </div>
      </div>
      <div v-else class="wish-list-contents__container">
        <WishListContentHeaderForCurrentUser
          v-if="isCurrentUser"
          :nickname="nickname"
          :edit-limit-path="editLimitPath"
          :edit-order-path="editOrderPath"
        />
        <WishListContentHeaderForOtherUser
          v-else
          :nickname="nickname"
          :is-wish-list-item-present="isWishListItemPresent"
        />
        <div class="wish-list-contents__body">
          <WishListContentItems
            :is-current-user="isCurrentUser"
            :user-wish-lists="userWishLists"
            :screen-name="screenName"
            :is-different-user-as-gift-card-recipient="
              isDifferentUserAsGiftCardRecipient
            "
            :is-app="isApp"
            @create-gift-card-error="showError"
            @delete-item-sku-error="showError"
            @complete-delete-item-sku="completeDeleteItemSku"
            @reached-limit-error-in-items="showReachedLimitError"
          />
          <WishListContentShareArea
            v-if="isCurrentUser"
            :host="host"
            :screen-name="screenName"
            @show-share-feedback="showFeedback"
          />
        </div>
      </div>
    </div>
    <div v-if="!isCurrentUser">
      <WishListContentFromAllGiftAria
        :is-app="isApp"
        :nickname="nickname"
        :screen-name="screenName"
        :is-wish-list-ticket-loading="isUserWishListsLoading"
        :is-different-user-as-gift-card-recipient="
          isDifferentUserAsGiftCardRecipient
        "
      />
    </div>
  </div>
</template>

<script>
import FeedbackSuccess from '../../../atoms/feedbacks/feedback-success.vue'
import FeedbackError from '../../../atoms/feedbacks/feedback-error.vue'
import SmallLoading from '../../../atoms/loadings/SmallLoading.vue'
import WishListContentHeaderForCurrentUser from '../../../organism/mypages/profiles/WishListContentHeaderForCurrentUser.vue'
import WishListContentHeaderForOtherUser from '../../../organism/mypages/profiles/WishListContentHeaderForOtherUser.vue'
import WishListContentItems from '../../../organism/mypages/profiles/WishListContentItems.vue'
import WishListContentShareArea from '../../../organism/mypages/profiles/WishListContentShareArea.vue'
import WishListContentEmptyForCurrentUser from '../../../organism/mypages/profiles/WishListContentEmptyForCurrentUser.vue'
import WishListContentEmptyForOtherUser from '../../../organism/mypages/profiles/WishListContentEmptyForOtherUser.vue'
import WishListContentFromAllGiftAria from '../../../organism/mypages/profiles/WishListContentFromAllGiftAria.vue'

import axios from 'axios'

export default {
  components: {
    FeedbackSuccess,
    FeedbackError,
    SmallLoading,
    WishListContentHeaderForCurrentUser,
    WishListContentHeaderForOtherUser,
    WishListContentItems,
    WishListContentShareArea,
    WishListContentEmptyForCurrentUser,
    WishListContentEmptyForOtherUser,
    WishListContentFromAllGiftAria
  },
  props: {
    isApp: {
      type: Boolean,
      required: true
    },
    isWishListItemPresent: {
      type: Boolean,
      require: true,
      default: false
    },
    isCurrentUser: {
      type: Boolean,
      require: true,
      default: false
    },
    nickname: {
      type: String,
      require: false,
      default: ''
    },
    editLimitPath: {
      type: String,
      require: false,
      default: ''
    },
    editOrderPath: {
      type: String,
      require: false,
      default: ''
    },
    itemsPath: {
      type: String,
      require: false,
      default: ''
    }
  },
  data() {
    return {
      screenName: '',
      host: '',
      showableSuccessFeedback: false,
      showableErrorFeedback: false,
      successMessage: '',
      errorMessage: '',
      userWishLists: [],
      isUserWishListsLoading: false,
      isDifferentUserAsGiftCardRecipient: false,
      showEmpty: false
    }
  },
  mounted() {
    this.showEmpty = !this.isWishListItemPresent
    // https://giftee.com/u/screen_name の screen_name を取得
    this.screenName = location.pathname.split('/')[2]
    // https://giftee.com/u/screen_name の giftee.com を取得
    this.host = location.host

    this.getUserWishLists()
    this.getWishListUserGiftCardEditingStatus()
  },
  methods: {
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    showFeedback(message) {
      this.showableSuccessFeedback = true
      this.successMessage = message
    },
    async getUserWishLists() {
      this.isUserWishListsLoading = true
      try {
        const res = await axios.get(
          `/api/v1/wish_lists?screen_name=${this.screenName}`
        )
        this.userWishLists = res.data.data.map(wishListTicket => {
          // TODO: dummyimage を正式が画像に置換する
          const itemSkuImageUrl = wishListTicket.attributes.item_sku_image_url
            ? wishListTicket.attributes.item_sku_image_url
            : 'https://dummyimage.com/90x90/ccc/999.png&text=Not+Found'
          return {
            id: wishListTicket.attributes.id,
            imageUrl: itemSkuImageUrl,
            itemSkuId: wishListTicket.attributes.item_sku_id,
            itemSkuName: wishListTicket.attributes.item_sku_name,
            itemId: wishListTicket.attributes.item_id,
            itemName: wishListTicket.attributes.item_name,
            brandName: wishListTicket.attributes.item_sku_brand_name,
            isSoldOut: wishListTicket.attributes.is_sold_out,
            hasLimit: wishListTicket.attributes.has_limit,
            wantedQuantity: wishListTicket.attributes.wanted_quantity,
            receivedQuantity: wishListTicket.attributes.received_quantity
          }
        })
        this.isUserWishListsLoading = false
        this.showEmpty = this.userWishLists.length === 0
      } catch (error) {
        this.isUserWishListsLoading = false
        this.showableErrorFeedback = true
        // error.response.data.message が null の場合に備えて初期値をセットする
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    async getWishListUserGiftCardEditingStatus() {
      try {
        const res = await axios.get(
          `/api/v1/pickup/gift_card_sessions/edit_status?screen_name=${this.screenName}`
        )
        this.isDifferentUserAsGiftCardRecipient = res.data.edit_status
      } catch (error) {
        this.showableErrorFeedback = true
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    showError(error) {
      this.showableErrorFeedback = true
      this.errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
    },
    async completeDeleteItemSku() {
      this.showFeedback('ほしいものリストから削除しました')
      await this.getUserWishLists()
    },
    async showReachedLimitError() {
      dataLayer.push({
        event: 'imp_wishlist__error_exceed'
      })
      window.scrollTo({ top })
      this.showableErrorFeedback = true
      this.errorMessage = 'エラーが発生しました'
      this.$emit('reached-limit-error')

      await this.getUserWishLists()
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-contents {
  &__container {
    margin: 0 auto;
    padding: 0;
    background-color: $white;
  }

  &__loading {
    padding: 24px;
    margin: auto;
  }
}
</style>
